// extracted by mini-css-extract-plugin
export var quantityInput = "_mp-0";